module.exports = __webpack_public_path__ + "static/media/feature-1.edfa7bc8.png";